module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_checkanswers-5d3df5357595ca4436a79679928ab3f5.jpg";